import React, { useEffect, useState } from "react"
import s from "./InvestmentInput.module.scss"
import cn from "classnames"
// import dynamic from "next/dynamic"
import InputMask from "react-input-mask"

export enum InvestmentInputSize {
    DEFAULT,
    SMALL,
}
interface InvestmentInputProps {
    max?: number
    label?: string
    currency: string
    placeholder: string
    inputText: string
    setInputText: React.Dispatch<React.SetStateAction<string>>
    inputWarning?: boolean
    setInputWarning?: React.Dispatch<React.SetStateAction<boolean>>
    size?: InvestmentInputSize
}

const DEFAULT_MAX = 10000000

export default function InvestmentInput({
    max = DEFAULT_MAX,
    size = InvestmentInputSize.DEFAULT,
    label,
    currency,
    placeholder,
    inputText,
    setInputText,
    inputWarning,
}: InvestmentInputProps) {
    const [value, setValue] = useState<string>(inputText)

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        try {
            const numericValue = Number(e.target.value.replace(/\s/g, ""))
            setValue(numericValue <= max ? e.target.value : max.toString().replace(/\s/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, " "))
        } catch (e) {
            // console.log(e)
        }
    }

    useEffect( () => {
        setValue(inputText)
    }, [inputText])

    useEffect( () => {
        setInputText(value)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value])


    const handleFormatInputValue = () => {
        let formattedValue = ""

        switch (value?.toString().replace(/\s/g, "").length) {
            case 1:
            case 2:
            case 3:
            case 6:
            case 9:
                formattedValue = "999 999 999 999"
                break
            case 4:
            case 7:
                formattedValue = "9 999 999 999"
                break
            case 5:
            case 8:
                formattedValue = "99 999 999 999"
                break
        }
        return formattedValue
    }

    return (
        <div className={cn(s["investment-input"], {
            [s["investment-input--small"]]: size === InvestmentInputSize.SMALL,
        })}>
            <div className={cn(s["investment-input__container"], {
                [s["investment-input__input--warning"]]: inputWarning,
            })}>
                <InputMask className={ cn(s["investment-input__input"]) }
                    style={{
                        width: `${value?.length > 0 ? value.length : placeholder.length ?? 1}ch`,
                    }}

                    value={ value } placeholder={ placeholder } inputMode="numeric" max={ max } mask={ handleFormatInputValue() } maskPlaceholder={ null } onChange={ onChange }  />
                <span className={cn(s["investment-input__currency"], inputWarning ? s["investment-input__currency--warning"] : "")}> {currency} </span>
            </div>
            { label && <label className={s["investment-input__label"]}>{ label }</label> }
        </div>
    )
}
